
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/panels/widgetPanels/slotSelectionExtendedPanel/slotPlaceholderItem.scss.css.virtualfile';
        module.exports = {"slotPlaceholderItem":"_slotPlaceholderItem_au5nj_1","slotPlaceholderItemTooltip":"_slotPlaceholderItemTooltip_au5nj_5"};